/** @format */

import {Box} from '@mui/material';

import {SwitcherRoot as Root, switcherClasses as classes} from './style';

interface Props {
  color: string;
  selected: boolean;
  onClick?: () => void;
}

const WidgetSwitcherButton = ({color, onClick, selected}: Props) => {
  return (
    <Root customColor={color} onClick={onClick} selected={selected}>
      <Box className={classes.switcherBackground} />
      <Box className={classes.switcherThumb}>
        <Box className={classes.switcherThumbHover} />
      </Box>
    </Root>
  );
};

export default WidgetSwitcherButton;
